import { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { supabase } from "../../../lib/supabase";

export default function AdminDashboard() {
  const [counts, setCounts] = useState({ categories: 0, products: 0, videos: 0 });

  useEffect(() => {
    const fetchCounts = async () => {
      const [cat, prod, vid] = await Promise.all([
        supabase.from("categories").select("*", { count: "exact", head: true }),
        supabase.from("ray_melo_products").select("*", { count: "exact", head: true }),
        supabase.from("videos").select("*", { count: "exact", head: true }),
      ]);
      setCounts({
        categories: cat.count ?? 0,
        products: prod.count ?? 0,
        videos: vid.count ?? 0,
      });
    };
    fetchCounts();
  }, []);

  const stats = [
    { label: "Categorias", value: counts.categories, icon: "ri-folder-line", href: "/admin/categories" },
    { label: "Produtos", value: counts.products, icon: "ri-t-shirt-line", href: "/admin/products" },
    { label: "Vídeos", value: counts.videos, icon: "ri-video-line", href: "/admin/videos" },
  ];

  return (
    <AdminLayout>
      <div>
        <div className="mb-8">
          <h1 className="text-xl font-light tracking-[0.15em] text-black uppercase" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Dashboard
          </h1>
          <p className="text-[11px] tracking-wide text-black/40 mt-1">
            Bem-vinda à área administrativa da Ray Melo Boutique
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          {stats.map((stat) => (
            <a
              key={stat.label}
              href={stat.href}
              className="bg-white border border-black/8 rounded-lg p-6 hover:border-black/20 transition-all cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-black/5 rounded-md group-hover:bg-black group-hover:text-white transition-all">
                  <i className={`${stat.icon} text-sm`} />
                </div>
                <span className="text-2xl font-light text-black">{stat.value}</span>
              </div>
              <p className="text-[11px] tracking-[0.15em] text-black/50 uppercase">{stat.label}</p>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-white border border-black/8 rounded-lg p-6">
            <h3 className="text-[11px] tracking-[0.2em] font-semibold text-black uppercase mb-4">Acesso Rápido</h3>
            <div className="space-y-2">
              {[
                { label: "Adicionar novo produto", href: "/admin/products", icon: "ri-add-line" },
                { label: "Criar nova categoria", href: "/admin/categories", icon: "ri-folder-add-line" },
                { label: "Editar vídeos", href: "/admin/videos", icon: "ri-video-add-line" },
                { label: "Configurações do site", href: "/admin/settings", icon: "ri-settings-3-line" },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="flex items-center gap-3 px-3 py-2.5 rounded-md text-[11px] tracking-wide text-black/60 hover:text-black hover:bg-black/5 transition-all cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${item.icon} text-sm`} />
                  </div>
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div className="bg-white border border-black/8 rounded-lg p-6">
            <h3 className="text-[11px] tracking-[0.2em] font-semibold text-black uppercase mb-4">Contato via WhatsApp</h3>
            <p className="text-[11px] tracking-wide text-black/50 leading-relaxed mb-4">
              Os produtos do site redirecionam clientes para o WhatsApp configurado:
            </p>
            <a
              href="https://wa.me/5511923169450"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] text-white text-[11px] tracking-[0.15em] px-4 py-2.5 rounded-md hover:bg-[#1fb855] transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-sm" />
              </div>
              (11) 92316-9450
            </a>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
